module.exports = __webpack_public_path__ + "img/img_18.439124b4.png";